import { effect } from "@preact/signals";
import * as preact from "preact";

import BookCollectionStore from "stores/BookCollectionStore";
import BookStore from "stores/BookStore";
import stores from "stores/stores";
import BookCoverConnector from "./BookCoverConnector";

export interface PublicLibraryListProps {
  bookFilter?: (bookModel: BookStore) => boolean;
  showNoTextsMessage?: boolean;
  rendered?: () => void;
  books: BookCollectionStore;
}

export class PublicLibraryList extends preact.Component<PublicLibraryListProps> {
  private disposeEffect?: () => void;

  componentDidMount() {
    this.disposeEffect = effect(() => {
      for (const book of this.props.books.books.value) {
        void book.book.value;
      }
      this.forceUpdate();
    });
    this.props.rendered?.();
  }

  componentWillUnmount() {
    this.disposeEffect?.();
  }

  render() {
    const filteredBooks = this.props.books.books.value.filter(
      (bookModel) =>
        !bookModel.book.value.parent &&
        (!this.props.bookFilter || this.props.bookFilter(bookModel))
    );

    return (
      <div>
        {filteredBooks.length === 0 && this.props.showNoTextsMessage ? (
          <p style="text-align:center;margin-top:20px">No texts found</p>
        ) : (
          filteredBooks.map((book) => (
            <BookCoverConnector
              book={book}
              key={book.id}
              userID={stores.user.id.value}
            />
          ))
        )}
      </div>
    );
  }
}
